riot.tag2('raq-cta-item', '<a href="{url}" if="{url}" target="{link.target}" class="{link.style}"> <span> {link.name} </span> </a>', '', 'class="raq-cta-item"', function(opts) {
    const self = this;
    const params = require('../../core/params');

    let setValues = true;
    let keyName = '';

    this.mixin('bus');

    function getParamValue(str) {
      let value = str;
      if (str.indexOf('[') !== -1) {
        keyName = str.replace('[', '').replace(']', '');
        value = self.userData[keyName];
      }
      return value;
    }

    function setUrlValues(itSelf) {
      self.userData = params.userData();
      let qStr = '';
      const url = itSelf.link.url;
      const paramObj = itSelf.link.parameters;
      const paramsObj = {};
      const parameters = [];

      if (Object.keys(paramObj).length > 0) {
        qStr = '?';
        Object.keys(paramObj).forEach((param) => {
          const value = getParamValue(paramObj[param]);
          if (value) {
            qStr += `${param}=${value}&`;
            paramsObj[param] = value;
          }
        });
        parameters.push(paramsObj);
        qStr = qStr.slice(0, -1);
      }
      self.url = (url.length > 0) ? url + qStr : false;
      self.parameters = parameters;
      self.update();
    }

    function updateCTA(force) {
      if (setValues || force) {
        setUrlValues(self);
        setValues = false;
      }
    }

    self.bus.on(self.bus.EVENTS.CONTAINER.MOUNTED, updateCTA);
    self.bus.on(self.bus.EVENTS.CONTAINER.CHANGESTATE, updateCTA(true));
});
